<template>
    <div class="nav-toolbar">
        <div class="menu-bars-small" @click="menuOpen">                        
            <div class="pointer">
                <i class="pi pi-bars"></i>
            </div>
        </div>
        <div class="tool-info">           
            <div class="dv-menu-title" v-if="MenuSelect && MenuSelect.data && MenuSelect.data.title">
                <span class="short-text">{{ $t(`menus.menu_${MenuSelect.data.title}`)}}</span>
            </div>
        </div>
        <div class="tool-options">
            <div class="pointer dv-command" @click="reloadPage">
                <i class="pi pi-undo" ></i>
            </div>
            <div class="pointer dv-command" @click="viewOptions">
                <i class="pi pi-cog" ></i>
            </div>
            <div class="pointer dv-command d-none" >
                <i class="pi pi-bell" ></i>
            </div>
        </div>
        <div class="tool-usr-info pointer" @click="viewOptions">
                      
            <img :src="imgUser" class="profile-img" v-if="imgUser" >
            <img src="../../assets/img/avatar2.png" class="profile-img" v-else>
            <span class="spn-name">
                {{ sesion.FullName }}
            </span>
            <span class="spn-profile">
                <b v-if="sesion.Type === 1">Root</b>
                <b v-if="sesion.Type === 2">{{ sesion.Cliente?.Code }}</b>
            </span>
        </div>        
    </div>
    <Dialog v-model:visible="showDialogOptions" 
                modal                                 
                :header="$t('Users.Options')">
        <ProfileConfigView :sesion="sesion" @onSave="onSaved"></ProfileConfigView>             
    </Dialog>
</template>
<script  setup lang="ts">
import { PropType, defineProps, onMounted, onUnmounted, ref,defineEmits } from 'vue';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { Subscription } from 'rxjs/internal/Subscription';
import ProfileConfigView from './ProfileConfigView.vue';
import Dialog from 'primevue/dialog';
import { IAppUserSettings } from '@/core/services/sys/AppSystemSettingsService';
import LoginService from '@/core/services/login/LoginService';

defineProps(
{
    sesion: { type: Object as PropType<ISesionApp>, required:true }
});
const emit = defineEmits(['onMenu']);

const MenuSelect = ref<any>(null);
let MenuSubscription: Subscription|null=null;
const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const showDialogOptions = ref<boolean>(false);
const imgUser = ref<string|null>(null);
const menuOpen = ()=>
{
    emit('onMenu',true);
}
const reloadPage = ()=>
{
    if(uiManager && uiManager.ReloadCurrentAction)
    {
        uiManager.ReloadCurrentAction();
    }
}
const viewOptions =()=>
{
    showDialogOptions.value = true;
}
const onSaved = (settings:IAppUserSettings) =>
{
    if(settings && settings.profileImg)
    {
        imgUser.value = 'data:image/png;base64,' + settings.profileImg;            
    }
    showDialogOptions.value = false;
}
onMounted(async()=>
{                           
    const appSettings = await loginService.getAppSettings(); 
    imgUser.value = appSettings.profileImg? 'data:image/png;base64,' + appSettings.profileImg:null;    
    MenuSubscription = uiManager.ActiveMenu.subscribe((x: any) => { MenuSelect.value = x; });
});
onUnmounted(() => {
    if(MenuSubscription)
    MenuSubscription.unsubscribe();
});
</script>